export const attendanceEmployee = {
  title: 'Individual productivity management',
}
